import { Directive, ElementRef, HostListener, Renderer2, HostBinding, Input, Output } from '@angular/core';
import { Device } from '../../models/device';
import { Port } from '../../models/port';
import { SelectedElementsService } from '../../services/selected-elements.service';
import { TrendService } from '../../services/trend.service';
import { DeviceService } from 'src/app/services/device.service';

@Directive({
  selector: '[app-select-port-or-device]',
})
export class SelectPortOrDeviceDirective {

  
  @Input() selected: boolean = false;
  
  @Input() device:Device;
  @Input() port: Port;

  

  @HostListener('click', ['$event'])
  onclick(event: MouseEvent) {


    console.log('click direc ', event)
    if(this.el.nativeElement.contains(event.target))
      console.log('is in the target')


    //console.log('click event', event);
    
    this.toggleSelected();
    /* console.log('device',this.device);
    console.log('port', this.port)
    console.log('selected', this.selected); */
    console.log(this.selectedElement.selectedPorts)


    console.log("======>", this.device)
  }


  constructor(private el: ElementRef, private renderer: Renderer2, private selectedElement:SelectedElementsService, 
    private trendService: TrendService, private deviceService: DeviceService) {
  }

  toggleSelected() {

    console.log('directive toggle', this.el.nativeElement.parentElement)

    if (this.selected === false) {
      this.selected = true;
      this.renderer.addClass(this.el.nativeElement.parentElement, 'selected')

      if(this.port !== undefined)
      this.selectedElement.selectedPorts.push(this.port);
      
      else if(this.device !== undefined)
        this.selectedElement.selectedDevices.push(this.device);
        console.log('sasasasasasasa', this.selectedElement.selectedDevices)

    }

    else if (this.selected === true) {
      this.selected = false;
      this.renderer.removeClass(this.el.nativeElement.parentElement, 'selected')
      
      if(this.port !== undefined)
      this.selectedElement.selectedPorts
      .splice(this.selectedElement.selectedPorts.findIndex(element => element.port_nid === this.port.port_nid), 1)

      else if(this.device !== undefined)
      this.selectedElement.selectedDevices
      .splice(this.selectedElement.selectedDevices.findIndex(element => element.dev_id === this.device.dev_id), 1)


    }

  }

  ngOnInit(): void {}

}
